module.exports = __webpack_public_path__ + "img/full5-min.dd78cd4c.png";